var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"loader-losange"},_vm._l((8),function(el){return _c('div',{staticClass:"loader-losange-element"})})),_vm._v(" "),_c('div',{staticClass:"loader-overlay"})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13cfab50","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/component/Loader/LoaderLosange.vue
// module id = uKp5
// module chunks = 0